
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2960_8520)"}},[_c('rect',{attrs:{"width":"40","height":"40","rx":"4","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M27.528 19.207a.837.837 0 00-.771-.476H22.75l1.602-8.327c.063-.331-.112-.66-.434-.816a.888.888 0 00-.973.134l-10.108 9.23a.726.726 0 00-.185.84.837.837 0 00.77.477h4.007l-1.601 8.327c-.064.33.111.66.433.816a.898.898 0 00.387.088.87.87 0 00.586-.222l10.108-9.231c.24-.22.313-.551.185-.84zm-9.6 7.273l1.316-6.846a.727.727 0 00-.181-.629.867.867 0 00-.64-.274h-2.972l6.802-6.211-1.317 6.846a.727.727 0 00.182.628c.159.174.392.275.639.275h2.972l-6.801 6.21z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2960_8520"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    